import Rest from '@services/Rest';

/**
 * @typedef {PaymentRequestService}
 */
export default class PaymentRequestService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/payment-request'
}
